<app-top-menu-two *ngIf="this.showTopMenu"></app-top-menu-two>
<div class="my-content" >
  <div style="max-width: 800px; margin: 0 auto;">

    <!--Nav Top-->
    <app-nav-top title="Meus pedidos" (back)="this.goback()"></app-nav-top>

    <div class="box" *ngIf="!this.requestSucess">
      <div class="box-orders">
          <div class="box-orders__order">
            <div class="title-order">
              <div class="title-order__spans" style="gap: 6px;">
                <div style="width: 135px; height: 27px; background-color: #cbd5dc; border-radius: 3px;">
                  <div class="pre-loading"></div>
                </div>
                <div style="width: 110px; height: 20px; background-color: #cbd5dc; border-radius: 3px;">
                  <div class="pre-loading"></div>
                </div>
              </div>
              <div style="width: 81px; height: 30px; background-color: #cbd5dc; border-radius: 3px;">
                <div class="pre-loading"></div>
              </div>
            </div>
            <div class="price-order" style="background-color: #cbd5dc; width: 65px; height: 20px; border-radius: 3px;">
              <div class="pre-loading"></div>
            </div>
            <div class="button-detail-order" style="background-color: #cbd5dc; padding-top: 0px;  border-radius: 3px;">
              <div class="pre-loading" style="width: 100%; height: 52px;"></div>
            </div>
          </div>
          <div class="box-orders__order">
            <div class="title-order">
              <div class="title-order__spans" style="gap: 6px;">
                <div style="width: 135px; height: 27px; background-color: #cbd5dc; border-radius: 3px;">
                  <div class="pre-loading"></div>
                </div>
                <div style="width: 110px; height: 20px; background-color: #cbd5dc; border-radius: 3px;">
                  <div class="pre-loading"></div>
                </div>
              </div>
              <div style="width: 81px; height: 30px; background-color: #cbd5dc; border-radius: 3px;">
                <div class="pre-loading"></div>
              </div>
            </div>
            <div class="price-order" style="background-color: #cbd5dc; width: 65px; height: 20px; border-radius: 3px;">
              <div class="pre-loading"></div>
            </div>
            <div class="button-detail-order" style="background-color: #cbd5dc; padding-top: 0px;  border-radius: 3px;">
              <div class="pre-loading" style="width: 100%; height: 52px;"></div>
            </div>
          </div>
          <div class="box-orders__order">
            <div class="title-order">
              <div class="title-order__spans" style="gap: 6px;">
                <div style="width: 135px; height: 27px; background-color: #cbd5dc; border-radius: 3px;">
                  <div class="pre-loading"></div>
                </div>
                <div style="width: 110px; height: 20px; background-color: #cbd5dc; border-radius: 3px;">
                  <div class="pre-loading"></div>
                </div>
              </div>
              <div style="width: 81px; height: 30px; background-color: #cbd5dc; border-radius: 3px;">
                <div class="pre-loading"></div>
              </div>
            </div>
            <div class="price-order" style="background-color: #cbd5dc; width: 65px; height: 20px; border-radius: 3px;">
              <div class="pre-loading"></div>
            </div>
            <div class="button-detail-order" style="background-color: #cbd5dc; padding-top: 0px;  border-radius: 3px;">
              <div class="pre-loading" style="width: 100%; height: 52px;"></div>
            </div>
          </div>
          <div class="box-orders__order">
            <div class="title-order">
              <div class="title-order__spans" style="gap: 6px;">
                <div style="width: 135px; height: 27px; background-color: #cbd5dc; border-radius: 3px;">
                  <div class="pre-loading"></div>
                </div>
                <div style="width: 110px; height: 20px; background-color: #cbd5dc; border-radius: 3px;">
                  <div class="pre-loading"></div>
                </div>
              </div>
              <div style="width: 81px; height: 30px; background-color: #cbd5dc; border-radius: 3px;">
                <div class="pre-loading"></div>
              </div>
            </div>
            <div class="price-order" style="background-color: #cbd5dc; width: 65px; height: 20px; border-radius: 3px;">
              <div class="pre-loading"></div>
            </div>
            <div class="button-detail-order" style="background-color: #cbd5dc; padding-top: 0px;  border-radius: 3px;">
              <div class="pre-loading" style="width: 100%; height: 52px;"></div>
            </div>
          </div>
      </div>

    </div>

    <!--View-->

    <div class="box" *ngIf="this.requestSucess">
      
      <ng-container *ngIf="this.orders">
        <div class="box-orders" *ngIf="this.orders.length != 0">
          <ng-container *ngFor="let order of orders; let last = last; let index = index">
              <!-- <div class="box-orders__order" [ngStyle]="{'padding-bottom.px': index == orders.length + 1 && this.theLastOrder ? 90 : 12}"> -->
              <div class="box-orders__order">
                <div class="title-order">
                  <div class="title-order__spans">
                    <span class="span-order">Pedido #{{ order.displayId}}</span>
                    <span class="span-date">Em {{order.createdAt | datetimeFormat }}</span>
                  </div>

                  <div [ngSwitch]="order.orderStatus">
                    <ng-container *ngSwitchCase="1">
                      <div class="button-status" *ngIf="order.scheduled && !order.production" style="background-color: #DAA520; border-radius: 5px;">
                        <span class="status-order">Agendado</span>
                      </div>
                      <div class="button-status" *ngIf="!order.scheduled || order.production" style="background-color: #FF8C00; border-radius: 5px;">
                        <span class="status-order">Aguardando confirmação</span>
                      </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="2">
                        <div class="button-status" *ngIf="order.scheduled && !order.production" style="background-color: #DAA520; border-radius: 5px;">
                          <span class="status-order">Agendado</span>
                        </div>
                        <div class="button-status" *ngIf="!order.scheduled || order.production" style="background-color: #1A73E8; border-radius: 5px;">
                          <span class="status-order">Em preparo</span>
                        </div>
                    </ng-container>

                    <div class="button-status" *ngSwitchCase="3" style="background-color: #28A745; border-radius: 5px;">
                      <span class="status-order">Pronto</span>
                    </div>
                    <div class="button-status" *ngSwitchCase="4" style="background-color: #28A745; border-radius: 5px;">
                      <span class="status-order">A caminho</span>
                    </div>
                    <div class="button-status" *ngSwitchCase="5" style="background-color: #a9a9a9; border-radius: 5px; border: 1px solid #a1a1a1;">
                      <span class="status-order">Finalizado</span>
                    </div>
                    <div class="button-status" *ngSwitchCase="0" style="background-color: #d70505; border-radius: 5px;">
                      <span class="status-order">Cancelado</span>
                    </div>
                    <div class="button-status" *ngSwitchCase="9" style="background-color: #E65100; border-radius: 5px;">
                      <span class="status-order">Aguardando pagamento</span>
                    </div>
                    <div class="button-status" *ngSwitchCase="10" style="background-color: #d70505; border-radius: 5px;">
                      <span class="status-order">Cancelado/Negado</span>
                    </div>
                    <div class="button-status" *ngSwitchCase="11" style="background-color: #6A1B9A; border-radius: 5px;">
                      <span class="status-order">Aguardando reembolso</span>
                    </div>
                    <div class="button-status" *ngSwitchCase="12" style="background-color: #4527A0; border-radius: 5px;">
                      <span class="status-order">Reembolso concluído</span>
                    </div>
                  </div>
                </div>
                
                <!-- #region Tempo de preparo-->

                  <!--Se for 2 é pedido com as propriedades de agendamento-->
                  <ng-container *ngIf="shouldShowTimeAwait(order)">
                    <app-time-await
                      [typeOrder]="order.orderType"
                      [visualization]="order.scheduled ? 2 : 1"
                      [scheduleStart]="order.scheduled ? order.scheduleStart : ''"
                      [scheduleEnd]="order.scheduled ? order.scheduleEnd : ''"
                      [createdAtOrder]="!order.scheduled ? order.createdAt : ''">
                    </app-time-await>
                  </ng-container>

                <!--#endregion-->

                <!--#region Contador cancelamento-->

                  <ng-container *ngIf="shouldShowCounter(order)">
                    <app-counter-cancelled *ngIf="order.onlinePay === 0 && company.configs.autoCancel === 1"
                      [createdAtOrder]="order.scheduled ? order.scheduledReceipt : order.createdAt"
                      [id_order]="order.id_order"
                      [id_company]="id_company">
                    </app-counter-cancelled>
                  </ng-container>
                
                <!--#endregion-->
                
                <!--Pix-->
                <app-input-copy-pix *ngIf="order.orderStatus == 9 && order.paymentForm[0].paymentForm == 0" [valueKey]="order.paymentForm[0].pixCode" [dateTimeTransation]="order.createdAt"></app-input-copy-pix>


                <!--Cartão-->
                <div class="counter-card-payment" *ngIf="order.orderStatus == 9 && (order.paymentForm[0].paymentForm == 7 || order.paymentForm[0].paymentForm == 9) && !order.paymentExpired">
                  <app-counter-timing [dateTimeTransaction]="order.createdAt" [fontSize]="'20px'" [minutes]="10" (finalizionCounter)="onFinalizeCounter($event, order)"></app-counter-timing>
                  <span class="text-information">Finalize o pagamento dentro do tempo limite para evitar o cancelamento do pedido.</span>
                </div>
                

                <!--Barra de Prograsso-->
                <app-progress-bar [order]="order" *ngIf="order.orderStatus != 5 && order.orderStatus != 0 && order.orderStatus != 10 && order.orderStatus != 11 && order.orderStatus != 12"></app-progress-bar>

  
                <!--Bottom-->
                <div class="price-order">
                  <span>{{ order.orderPrice | currency:'BRL' }}</span>

                  <div class="orde-detail-button" [routerLink]="['/', this.nameCompany, 'order-details', order.id_order]">
                    <span>Ver detalhes</span>
                    <div class="icon-chevron-right" style="font-size: 18px;"></div>
                  </div>
                </div>

                <div class="button-detail-order" *ngIf="order.onlinePay == 1 && order.orderStatus == 9 && (order.paymentForm[0].paymentForm == 7 || order.paymentForm[0].paymentForm == 9) && order.paymentForm[0].linkCheckout != ''">
                  <button (click)="finalizarPagamento(order)" style="background-color: var(--primary-color); color: white;">Finalizar pagamento</button>
                </div>

                <!-- <div>
                  <div class="button-detail-order" *ngIf="order.onlinePay == 1 && order.orderStatus == 9 && order.paymentForm[0].paymentForm == 7">
                    <button (click)="finalizarPagamento(order)">Finalizar pagamento</button>
                  </div>

                  <div class="button-detail-order">
                    <button [routerLink]="['/', this.nameCompany, 'order-details', order.id_order]">Detalhes do pedido</button>
                  </div>
                </div> -->

              </div>
          </ng-container>
        </div>
      </ng-container>


      <ng-container *ngIf="!this.orders">
        <div class="not-order">
          <span>Nenhum pedido encontrado</span>
        </div>
      </ng-container>


      <ng-container *ngIf="this.totalOrders">
        <div class="button_plus_orders" *ngIf="this.totalOrders > 3 && this.totalOrders > this.quantityOrders">
          <button (click)="this.subquantityOrders()">Carregar mais</button>
        </div>
      </ng-container>

    </div>
  </div>
</div>
<!-- <app-bottom-menu></app-bottom-menu> -->
